import { useQuery } from '@tanstack/react-query';

import { EQueryKeys } from '@/shared/config';

import { defaultCountryQuery } from '../api';
import { DEFAULT_COUNTRY_CODE } from '../config';

export const useDefaultCountryController = () => {
  useQuery({
    queryKey: [EQueryKeys.DefaultCountryQueryKey],
    queryFn: async () => await defaultCountryQuery(DEFAULT_COUNTRY_CODE),
  });
};
